import PaginatedTable from './PaginatedTable';
import Table from './Table';

export type { Cell, Column, Row } from './types';

export { PaginatedTable };

export default Table;
